<template>
  <BittsModal
    :loading="!!report ? false : !ready"
    :use-mask-to-close="true"
    :visible="true"
    :show-close-button="false"
    class="share-report-modal"
    :width="520"
    :hide-footer="true"
    variant="data"
    @closed="onCloseModal"
  >
    <ReportAccessSelectionControls
      v-if="report"
      :report="report"
      class="w-full"
      @close="onCloseModal"
    />
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { computed, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import ReportAccessSelectionControls from '@/components/reports/ReportAccessSelectionControls.vue';

import { ProvidedReportState } from '@/injectionKeys/lists';
import { allReady, useReportsStore, useTeamStore } from '@/stores';

const route = useRoute();
const router = useRouter();

const reportsStore = useReportsStore();
const teamStore = useTeamStore();
const ready = allReady(teamStore, reportsStore);

const reportId = computed(
  () => (route.query.id || route.params.report_id) as string,
);
const providedReportState = inject(ProvidedReportState);
const providedReport = computed(() => providedReportState?.report?.value);
const report = computed(() => {
  const provided = providedReport.value;
  if (provided?.id === reportId.value) return provided;
  return (
    reportsStore.getByReportId(reportId.value) ??
    (provided?.name ? provided : null)
  );
});

const folderId = computed(() => route.params.folder_id);
const fromReportDetail = computed(() => route.params.report_id);
const closeRoute = computed(() => {
  if (fromReportDetail.value)
    return {
      name: 'edit_report',
      params: { report_id: fromReportDetail.value },
    };
  if (route.name?.toString().includes('partner_details')) {
    return {
      name: 'partner_details',
      params: { partner_org_id: route.params.partner_org_id },
    };
  } else if (route.name?.toString().includes('lists')) {
    return { name: 'lists' };
  }
  if (!folderId.value) return { name: 'reports' };
  return {
    name: 'folder',
    params: { folder_id: folderId.value },
  };
});
async function onCloseModal() {
  await router.push(closeRoute.value);
}
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.bitts-callout:deep() .bitts-callout__text .bitts-callout__title {
  @apply font-normal;
}
.share-report-modal.o-bitts-modal.bitts-modal--data:deep() dialog {
  .o-bitts-modal__header {
    @apply pt-0 border-none;
  }
  .o-bitts-modal__content {
    @apply py-16 pt-0 pb-0 m-0;
  }
}

.report-access-selection-controls {
  @apply p-0;
}

.o-bitts-modal:deep() dialog .close-icon {
  top: 8px;
  right: 8px;
}
</style>
